import type { ReactNode } from "react";

type MetricCardProps = {
  label: string;
  value: string;
  note?: ReactNode;
  tone?: "mint" | "yellow" | "pink" | "blue";
};

export function MetricCard({ label, value, note, tone = "mint" }: MetricCardProps) {
  return (
    <article className={`metric metric--${tone}`}>
      <p className="metric__label">{label}</p>
      <strong className="metric__value">{value}</strong>
      {note && <p className="metric__note">{note}</p>}
    </article>
  );
}
